// extracted by mini-css-extract-plugin
export default {"page":"page_FlOIt","isWebView":"isWebView_NXW3a","buttons":"buttons_V2t5d"};